import { render, staticRenderFns } from "./PatientOutcome.vue?vue&type=template&id=2655d631&"
import script from "./PatientOutcome.vue?vue&type=script&lang=js&"
export * from "./PatientOutcome.vue?vue&type=script&lang=js&"
import style0 from "./PatientOutcome.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports